import { CLEAR_INCENTIVE_VALIDATION_ERROR, SET_INCENTIVE_VALIDATION_ERROR } from '../actionTypes/incentivesActionTypes';

export const setIncentiveValidationError = (errorMessage: string, hasErrors: boolean) => ({
    type: SET_INCENTIVE_VALIDATION_ERROR,
    payload: { errorMessage, hasErrors }
});

export const clearIncentiveValidationError = () => ({
    type: CLEAR_INCENTIVE_VALIDATION_ERROR
});
